import { connect } from 'react-redux';

import FoodSafetyQualityComponent from '../../components/quality/FoodSafetyQuality';

const FoodSafetyQuality = connect()(FoodSafetyQualityComponent);

export default FoodSafetyQuality;
